<template>

  <loading-data-page-container :loading="loading"
                               :loading-error="loadingError"
                               :loading-error-message="loadingErrorMsg"
                               class="antraege--page">

    <v-container v-if="!loading && !loadingError" class="pa-0" fluid>

      <div class="semanticsection-title2 primary--text">Offene Anträge</div>

      <table-container @excel="exportExcel"
                       @reset-filters="resetSingleFilter">
        <!--- full search ----------------------------------------------------------------------------->
        <v-text-field slot="full-search"
                      v-model="search"
                      label="Nach Antrag suchen"
                      append-icon="search"
                      single-line
                      hide-details
                      clearable />

        <!--- detail filters ----------------------------------------------------------------------------->
        <v-row slot="detail-filters"
                  no-gutters
                  class="detail--filters">
          <v-col cols="12"
                 sm="6"
                 md="4">
            <date-field v-model="singleFilters.Erstellt.von"
                        v-validate="'date_format:DD.MM.YYYY'"
                        :clear-icon-cb="applySingleFilter"
                        hide-details
                        clearable
                        label="Erstellt von"
                        class="mb0 date--field"
                        @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <date-field v-model="singleFilters.Erstellt.bis"
                        v-validate="'date_format:DD.MM.YYYY'"
                        :clear-icon-cb="applySingleFilter"
                        hide-details
                        clearable
                        label="Erstellt bis"
                        class="date--field"
                        @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-text-field v-model="singleFilters.Name"
                          clearable
                          hide-details
                          label="Name"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-text-field v-model="singleFilters.Produkt"
                          clearable
                          hide-details
                          label="Produkt"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-text-field v-model="singleFilters.Versicherungsumfang"
                          clearable
                          hide-details
                          label="Versicherungsumfang"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-text-field v-model="singleFilters.Angebotsnummer"
                          clearable
                          hide-details
                          label="Vorgangsnummer"
                          @input="applySingleFilter" />
          </v-col>
        </v-row>

        <antraege-table ref="antraegeTable"
                        :antraege="filteredAntraege"
                        :search="search"
                        @details="details" />

      </table-container>
      <div class="dmb-form-text warning--text">{{ loadingErrorMsg }}</div>

    </v-container>

  </loading-data-page-container>

</template>
<script>
import httpService from '@/helper/httpService';
import DateField from "@/components/DateField";
import TableContainer from "@/components/kundenverwaltung/TableContainer";
import AntraegeTable from "@/components/kundenverwaltung/OffeneAntraegeTable";
import ExcelMixin from '@/pages/kundenverwaltung/ExcelMixin';
import TableDataMixin from '@/pages/kundenverwaltung/TableDataMixin';
import ParsingMixin from '@/pages/kundenverwaltung/ParsingMixin';
import {modernAntraege, legacyAntraege} from '@/store/dummyData/Antraege';
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";
import {PRODUKTE_VALUES} from "@/components/kundenverwaltung/valueLists";

import {CONNECTION_ERROR_MESSAGE} from "../../helper/httpService";

function combineAntraegeFiltered(backendResult) {
  const filteredLegacy = backendResult.legacyResult.filter(
    legacyAntrag => !backendResult.modernResult.some(modernAntrag => modernAntrag.angebotsnummer === legacyAntrag.angebotsnummer));

  return backendResult.modernResult.concat(filteredLegacy);
}

export default {
  name: "OffeneAntraegePage",
  components: {
    LoadingDataPageContainer, AntraegeTable, TableContainer, DateField
  },
  mixins: [ExcelMixin, TableDataMixin, ParsingMixin],
  data() {
    return {
      loading: true,
      loadingError: false,
      loadingErrorMsg: '',
      antraege: [],
      formattedAntraege: [],
      filteredAntraege: [],
      search: '',
      singleFilters: this.getInitalFilterState()
    };
  },
  created() {
    httpService.getAntraege()
      .then(result => {
        this.loadingErrorMsg = "";

        // combine modern and legacy antraege - avoid duplicates, keep modern in that case
        this.antraege = combineAntraegeFiltered(result);

        this.formattedAntraege = this.antraege.map(this.formatData);
        this.filteredAntraege = [].concat(this.formattedAntraege);

        result.errors.forEach(error => console.log(`GET Applications failed with ${error.status}: ${error.message}`));

        if (result.errors.length === 2) {
          // both (= all) requests failed
          if (this.$store.state.env.environment === 'development') {
            //TODO delete dummy data for production
            this.antraege = combineAntraegeFiltered({ modernResult: modernAntraege, legacyResult: legacyAntraege });

            this.formattedAntraege = this.antraege.map(this.formatData);
            this.filteredAntraege = [].concat(this.formattedAntraege);
          } else {
            // only first error used for frontend message
            this.loadingErrorMsg = result.errors[0].status < 500 ? 'Keine Anträge gefunden' : CONNECTION_ERROR_MESSAGE;
            this.loadingError = true;
          }
        } else if (result.errors.length > 0) {
          this.loadingErrorMsg = "Anträge konnten nur teilweise geladen werden.";
        }
        this.loading = false;
      });
  },
  methods: {
    formatData: function (antrag) {
      if (!antrag.categories && antrag.productLine === "Privat") {
        // legacy privat antrag, set categories
        antrag.categories = antrag.scope.split("");
      }

      let frontEndName = "";
      if (antrag.vn) {
        frontEndName = [antrag.vn.lastname, antrag.vn.firstname].filter(name => !!name).join(', ');
      } else if (antrag.personen) {
        const vn = antrag.personen.find(p => p.key === 'vn1');
        if (vn) frontEndName = vn.name + ' ' + vn.rechtsform;
      }

      const gewerbeProdukt = antrag.vertrag && antrag.vertrag.produktcode ?
        PRODUKTE_VALUES.find(p => p.code === antrag.vertrag.produktcode) : null;
      const Produkt = gewerbeProdukt ? gewerbeProdukt.text : this.$store.getters.productLineText(antrag.productLine, antrag.selectedTarif);

      const Versicherungsumfang = Array.isArray(antrag.categories) ? this.getUmfangFromCategories(antrag.categories)
        : Array.isArray(antrag.deckungen) ? this.getUmfangFromDeckungen(antrag.deckungen) : antrag.scope;

      return {
        Name: frontEndName,
        Angebotsnummer: antrag.angebotsnummer,
        Produkt,
        Versicherungsumfang,
        sortableVersicherungsumfang: Versicherungsumfang.length + Versicherungsumfang,
        Erstellt: this.$helpers.dateToTime(antrag.submitTime),
        pdfpfad: antrag.pdfpfad
      };
    },
    details: function (angebotsnummer) {
      const antrag = this.antraege.find(antrag => antrag.angebotsnummer === angebotsnummer);
      const url = `${antrag.pdfpfad}${antrag.pdfpfad.indexOf('?') < 0 ? "?" : "&"}disposition=inline`;
      window.open(url, '_blank');
    },
    exportExcel: function () {
      this.generateExcel([].concat(this.antraege.map(this.formatAntraegeDataForExcel)), this.columnFormatAntraegeDataForExcel(), "Antraege");
    },
    getInitalFilterState() {
      return {
        'Angebotsnummer': '',
        'Name': '',
        'Produkt': '',
        'Versicherungsumfang': '',
        'Erstellt': {
          von: '',
          bis: ''
        }
      };
    },
    applySingleFilter() {
      this.filteredAntraege = this.formattedAntraege.filter(row => {
        if ((this.singleFilters.Erstellt.von || this.singleFilters.Erstellt.bis)
          && !this.filterDateBetween(row.Erstellt, this.singleFilters.Erstellt.von, this.singleFilters.Erstellt.bis)) {
          return false;
        }
        //apply standard filter for remaining header line filters
        const vals = ['Angebotsnummer', 'Name', 'Produkt', 'Versicherungsumfang'];
        for (let i = 0; i < vals.length; i++) {
          const columnName = vals[i];
          if (this.singleFilters[columnName] && !this.filterDefault(row[columnName], this.singleFilters[columnName])) {
            return false;
          }
        }
        return true;
      });
    },
    resetSingleFilter() {
      this.singleFilters = this.getInitalFilterState();
      this.applySingleFilter();
    },
  }
};
</script>
<style>
.antraege--page .v-input:not(.v-input--selection-controls) {
  max-width: 344px;
}

.antraege--page .detail--filters div[class*=col-] {
  display: flex;
  justify-content: center;
  padding: 0 20px;
}
</style>
